import { InputBase } from '@mui/material';
import Fuse from 'fuse.js';
import { useState, useMemo, useEffect } from 'react';
import { useStockItemsQuery } from '@features/stock/queries';
import { mapStocksStockItemsToFlatStockItems } from '@features/stock/entity';
import { setMaterialSearchResults } from '@libs/redux/materialSearchResultsReducer';
import { useAppDispatch } from '@libs/redux/store';
import { useDebounce } from '@shared/store';
import { useIntl } from 'react-intl';

const MaterialSearch = () => {
  const intl = useIntl();
  const { data: stocksWithItems } = useStockItemsQuery(undefined);
  const allItems = mapStocksStockItemsToFlatStockItems(stocksWithItems) ?? [];
  const materialItems = useMemo(() => allItems.filter(i => i.itemType === 'MATERIAL'), [allItems]);

  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 200);
  const dispatch = useAppDispatch();

  const fuse = useMemo(
    () =>
      new Fuse(materialItems, {
        keys: ['itemName'],
        threshold: 0.4,
      }),
    [materialItems],
  );

  const results = useMemo(
    () =>
      debouncedQuery.trim()
        ? fuse.search(debouncedQuery).map(r => r.item)
        : materialItems.slice(0, 10),
    [debouncedQuery, fuse, materialItems],
  );

  useEffect(() => {
    dispatch(setMaterialSearchResults(results));
  }, [results, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setMaterialSearchResults([]));
    };
  }, [dispatch]);

  return (
    <InputBase
      placeholder={intl.formatMessage({ id: 'search.material' })}
      value={query}
      onChange={e => setQuery(e.target.value)}
      sx={{ color: '#ffffff' }}
    />
  );
};

export default MaterialSearch;
